import { render, staticRenderFns } from "./successDetail.vue?vue&type=template&id=51b9ce4e&scoped=true&"
import script from "./successDetail.vue?vue&type=script&lang=js&"
export * from "./successDetail.vue?vue&type=script&lang=js&"
import style0 from "./successDetail.vue?vue&type=style&index=0&id=51b9ce4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9ce4e",
  null
  
)

export default component.exports